import React from 'react';
import { Outlet, useRoutes } from 'react-router-dom';
import Navigation from './Navigation';
import SalePurchaseEntry from './Master/SalePurchaseEntry';
import SalePurchaseTbl from './MasterTables/SalePurchaseTable/SalePurchaseTbl';
import SalePurchaseEdit from './MasterEdit/SalePurchaseEdit';
import ItemMaster from './Master/ItemMaster';
import ItemTbl from './MasterTables/ItemTable/ItemTbl';
import ItemEdit from './MasterEdit/ItemEdit';
import NewItemEntry from './NewEntry/NewItemEntry';
import LoginPage from './LoginPage';
import DashboardPHP from './DashboardPHP';
import ZoneEntry from './Master/ZoneEntry';
import LocationEntry from './Master/LocationEntry';
import ZoneReg from './MasterTables/ZoneTbl/ZoneReg';
import LocationReg from './MasterTables/LocationTbl/LocationReg';
import StkInwEntry from './Stock/StkInwEntry';
import StkInwView from './Stock/StkInwView';
import StkInwReg from './Stock/StkInwReg';
import AdminSaleEntry from './SaleEntry/AdminSaleEntry';
import AdminSaleView from './SaleEntry/AdminSaleView';
import StockReg from './Stock/StockReg';
import UserSaleEntry from './SaleEntry/UserSaleEntry';
import AdminSaleReg from './SaleEntry/AdminSaleReg';
import StudentSaleRegister from './SaleEntry/StudentSaleReg';
import UserSaleReg from './SaleEntry/UserSaleReg';
import LocEntry2 from './Master/LocEntry2';
import UStkInwEntry from './UserStockInw/UStkInwEntry';
import AdminSalePrint from './SaleEntry/AdminSalePrint';
import StudentSalePrint from './SaleEntry/StudentSalePrint';
import FirmEdit from './MasterEdit/FirmEdit';
import FirmEntry from './Master/FirmEntry';
import FirmTable from './MasterTables/FirmTable/FirmTable';
import UstkInwView from './UserStockInw/UstkInwView';
import UstkRtInwView from './Return/UstkRtInwView';
import UstkInwReg from './UserStockInw/UstkInwReg';
import UserSalePrint from './SaleEntry/UserSalePrint';
import StkInwPrint from './Stock/StkInwPrint';
import UstkDetailsReg from './UserStockInw/UstkDetailsReg';
import StudentEntry from './Master/StudentEntry';
import StudentReg from './MasterTables/StudentTbl/StudentReg';
import StudentRegWhatsapp from './MasterTables/StudentTbl/StudentRegWhatsapp';
import UserRegEntry from './Master/UserRegEntry';
import SubUserReg from './MasterTables/SubUserTbl/SubUserReg';
import SubUserView from './MasterTables/SubUserTbl/SubUserView';
import AdminSaleEdit from './SaleEntry/AdminSaleEdit';
import StudentSaleEdit from './SaleEntry/StudentSaleEdit';
import UserDashboard from './UserDashbord';
import UserDashbord1 from './UserDashbord';
import ZoneEdit from './MasterEdit/ZoneEdit';
import AdSaleCancelReg from './SaleEntry/AdSaleCancelReg';
import AdSaleCancelPrint from './SaleEntry/AdSaleCancelPrint';
import CommonStockReg from './Stock/CommonStockReg';
import SchoolEdit from './MasterEdit/SchoolEdit';
import StudentEdit from './MasterEdit/StudentEdit';
import UserSaleEdit from './SaleEntry/UserSaleEdit';
import UstkInwPrint from './UserStockInw/UstkInwPrint';
import UstkRtInwPrint from './UserStockInw/UstkRtInwPrint';
import NewStudentEntry from './NewEntry/NewStudentEntry';
import UserEdit from './MasterEdit/UserEdit';
import AdminSaleReport from './Reports/AdminSaleReport';
import UserSaleReportReg from './Reports/UserSaleReport';
import AdminReportView from './Reports/AdminReportView';
import AdminItemReport from './Reports/AdminItemReport';
import StkInwEdit from './Stock/StkInwEdit';
import AdminSaleAdd from './SaleEntry/AdminsaleAdd';
import StudentSaleAdd from './SaleEntry/StudentSaleAdd';
import UcommonStkReg from './UserStockInw/UcommonStkReg';
import AdItemRepView from './Reports/AdItemRepView';
import ManualStkEntry from './UserStockInw/ManualStkEntry';
import AdUsSaleRepView from './Reports/AdUsSaleRepView';
import UserReturnEntry from './Return/ReturnEntry';
import UserReturnReg from './Return/ReturnReg';
import UserReturnPrint from './Return/UserReturnPrint';
import UserReturnEdit from './Return/UserReturnEdit';
import UserReturnInwardEntry from './Return/UserReturnInwardEntry';
import UserReturnInwardReg from './UserStockInw/UserReturnInwardReg';
import StudentSaleEntry from './SaleEntry/StudentSaleEntry';
import UserStkBillView from './UserStockInw/UserStkBillView';


export default function Router() {

    const mainRoutes = useRoutes([
        {
            index: true,
            element: <LoginPage />
        },
        {
            element: (
                <Navigation>
                    <Outlet />
                </Navigation>
            ),
            children: [
                { path: 'Dashboard', element: <DashboardPHP /> },
                { path: 'user-dashboard', element: <UserDashboard /> },
                { path: 'user-dashbord', element: <UserDashbord1 /> },
                { path: 'SalePurchaseEntry', element: <SalePurchaseEntry /> },
                { path: 'SalePurchaseTable', element: <SalePurchaseTbl /> },
                { path: 'ItemEntry', element: <ItemMaster /> },
                { path: 'ItemTable', element: <ItemTbl /> },
                { path: 'zone-entry', element: <ZoneEntry /> },
                { path: 'zone-register', element: <ZoneReg /> },
                { path: 'school-entry', element: <LocationEntry /> },
                { path: 'school-register', element: <LocationReg /> },
                { path: 'stock-inward-entry', element: <StkInwEntry /> },
                { path: 'stock-inward-register', element: <StkInwReg /> },
                { path: 'stock-register', element: <StockReg /> },
                { path: 'admin-sale-entry', element: <AdminSaleEntry /> },
                { path: 'admin-sale-register', element: <AdminSaleReg /> },
                { path: 'student-sale-entry', element: <StudentSaleEntry /> },
                { path: 'student-sale-register', element: <StudentSaleRegister /> },
                { path: 'user-sale-entry', element: <UserSaleEntry /> },
                { path: 'user-sale-register', element: <UserSaleReg /> },
                { path: 'user-return-entry', element: <UserReturnEntry /> },
                { path: 'user-return-reg', element: <UserReturnReg /> },
                { path: 'user-return-stock-inward-entry', element: <UserReturnInwardEntry /> },
                { path: 'user-return-stock-inward-register', element: <UserReturnInwardReg /> },

                { path: 'location-entry', element: <LocEntry2 /> },
                { path: 'user-stkinward-entry', element: <UStkInwEntry /> },
                { path: 'FirmEntry', element: <FirmEntry /> },
                { path: 'FirmTable', element: <FirmTable /> },
                { path: 'user-stkinward-register', element: <UstkInwReg /> },
                { path: 'schl-stock-register', element: <UstkDetailsReg /> },
                { path: 'student-entry', element: <StudentEntry /> },
                { path: 'student-register', element: <StudentReg /> },
                { path: 'student-register-whatsapp', element: <StudentRegWhatsapp /> },
                { path: 'user-reg-entry', element: <UserRegEntry /> },
                { path: 'subuser-reg', element: <SubUserReg /> },
                { path: 'admin-sale-cancel-register', element: <AdSaleCancelReg /> },
                { path: 'stock-common-register', element: <CommonStockReg /> },
                { path: 'admin-sale-report', element: <AdminSaleReport /> },
                { path: 'user-sale-report', element: <UserSaleReportReg /> },
                { path: 'admin-item-report', element: <AdminItemReport /> },
                { path: 'school-common-stock', element: <UcommonStkReg /> },
                { path: 'manual-school-inward', element: <ManualStkEntry /> },
            ]
        },
        { path: 'NewItemEntry', element: <NewItemEntry /> },
        { path: 'new-student-entry', element: <NewStudentEntry /> },
        { path: 'SalePurchaseEdit/:Id', element: <SalePurchaseEdit /> },
        { path: 'ItemEdit/:Id', element: <ItemEdit /> },
        { path: 'stock-inward-view', element: <StkInwView /> },
        { path: 'admin-sale-view', element: <AdminSaleView /> },
        { path: 'admin-sale-print/:Id', element: <AdminSalePrint /> },
        { path: 'student-sale-print/:Id', element: <StudentSalePrint /> },
        { path: 'admin-sale-add/:Id', element: <AdminSaleAdd /> },   // Add
        { path: 'student-sale-add/:Id', element: <StudentSaleAdd /> },   // Add
        { path: 'FirmEdit/:Id', element: <FirmEdit /> },
        { path: 'user-stock-inward-view', element: <UstkInwView /> },
        { path: 'user-return-stock-inward-view', element: <UstkRtInwView /> },
        { path: 'user-sale-print/:Id', element: <UserSalePrint /> },
        { path: 'user-return-print/:Id', element: <UserReturnPrint /> },
        { path: 'stock-inward-print/:Id', element: <StkInwPrint /> },
        { path: 'subuser-view/:Id', element: <SubUserView /> },
        { path: 'admin-sale-edit/:Id', element: <AdminSaleEdit /> },
        { path: 'student-sale-edit/:Id', element: <StudentSaleEdit /> },
        { path: 'zone-edit/:Id', element: <ZoneEdit /> },
        { path: 'admin-sale-cancel-print/:Id', element: <AdSaleCancelPrint /> },
        { path: 'school-edit/:Id', element: <SchoolEdit /> },
        { path: 'student-edit/:Id', element: <StudentEdit /> },
        { path: 'user-sale-edit/:Id', element: <UserSaleEdit /> },
        { path: 'user-return-edit/:Id', element: <UserReturnEdit /> },
        { path: 'user-stock-print/:Id', element: <UstkInwPrint /> },
        { path: 'user-stock-rtinward-print/:Id', element: <UstkRtInwPrint /> },
        { path: 'sub-user-edit/:Id', element: <UserEdit /> },
        { path: 'admin-sale-report-view/:Id', element: <AdminReportView /> },
        { path: 'stock-inward-edit/:Id', element: <StkInwEdit /> },
        { path: 'admin-item-report-view/:Id', element: <AdItemRepView /> },
        { path: 'user-item-report-view/:Id', element: <AdUsSaleRepView /> },
        { path: 'user-stock-bill-view/:Id', element: <UserStkBillView /> },
    ])
    return mainRoutes;
}
